import LanguageSwitcher from '@components/LanguageSwitcher'
import useIsContentForceCentered from '@hooks/useIsContentForceCentered'
import {
  desktopCenteredContentCSS,
  mobileCSS,
  tabletCSS,
} from '@measures/responsive'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import BurgerMenu from './BurgerMenu'
import ButtonsContainer from './ButtonsContainer'
import Logo from './Logo'
import SearchInput from './SearchInput'
import UserMenu from './UserMenu'
import Weather from './Weather'

const StyledFirstRow = styled.div<{ isContentForceCentered: boolean }>`
  ${({
    theme: {
      colors: {
        white,
        brandColors: { brand_55 },
      },
    },
    isContentForceCentered,
  }) => css`
    background-color: ${white};
    border-bottom: 2px solid ${brand_55};
    z-index: 2;
    position: relative;

    display: grid;
    grid-template-columns: 994px;
    height: 60px;

    ${desktopCenteredContentCSS(
      css`
        justify-content: center;
      `
    )}

    ${isContentForceCentered &&
    css`
      justify-content: center;
    `}

    ${tabletCSS(css`
      grid-template-columns: 1fr;
    `)}

    ${mobileCSS(css`
      grid-template-columns: 1fr;
      height: 48px;
    `)}
  `}
`

const MainContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
`

const StyledWeather = styled(Weather)`
  ${mobileCSS(css`
    display: none;
  `)}
`

const StyledSearchInput = styled(SearchInput)`
  ${mobileCSS(css`
    display: none;
  `)}
`

const FirstRow: FunctionComponent = () => {
  const isContentForceCentered = useIsContentForceCentered()
  return (
    <StyledFirstRow isContentForceCentered={isContentForceCentered}>
      <MainContainer>
        <Logo />
        <ButtonsContainer>
          <LanguageSwitcher />
          <StyledWeather />
          <StyledSearchInput />
          <UserMenu />
          <BurgerMenu />
        </ButtonsContainer>
      </MainContainer>
    </StyledFirstRow>
  )
}

export default FirstRow
